import { DefaultResponseModel } from "@/types/http";
import http, { getAuthorizationToken, getRefreshToken } from "../utils/http-client";

export interface RegisterGuestArguments {
  username: string;
  password: string;
  email: string;
}

export const registerGuest = (data: RegisterGuestArguments) => {
  return http.post<DefaultResponseModel>({
    url: "/api/register",
    data: data,
    requiresAuth: false,
    unprocessed: true,
  });
};

export const loginGuest = (username: string, password: string) => {
  return http.post<GuestLoginModel>({
    url: "/api/login",
    data: {
      username,
      password,
    },
    requiresAuth: false,
  });
};

/**
 * 获取用户详情
 */
export const getUserDetail = () => {
  return http.get<UserDetailModel>({
    url: "/api/user/detail",
  });
};

interface WeChatAccessToken {
  access_token: string;
  expires_in: number;
}
/**
 * 获取微信分享 access_token
 */
export const get_we_chat_access_token = () => {
  return http.get<WeChatAccessToken>({
    url: "/api/user/access_token",
  });
};

export interface JSApiTicket {
  ticket: string;
  expires_in: number;
}
/**
 * 获取微信分享 jsapi_ticket
 */
export const get_we_chat_jsapi_ticket = (access_token: string) => {
  return http.post<JSApiTicket>({
    url: "/api/user/jsapi_ticket",
    data: {
      access_token: access_token,
    },
  });
};

interface WeChatAccessToken {
  access_token: string;
  expires_in: number;
}
/**
 * 获取企业微信分享 access_token
 */
export const get_we_team_access_token = () => {
  return http.get<WeChatAccessToken>({
    url: "/api/user/qy_access_token",
  });
};

export interface JSApiTicket {
  ticket: string;
  expires_in: number;
}
/**
 * 获取企业微信分享 jsapi_ticket
 */
export const get_we_team_jsapi_ticket = (access_token: string) => {
  return http.post<JSApiTicket>({
    url: "/api/user/qy_jsapi_ticket",
    data: {
      access_token: access_token,
    },
  });
};


//校验token有效性
export const verify_token = () => {
  return http.post<DefaultResponseModel>({
    url: "/api/token/verify",
    data: {
      token: getAuthorizationToken(false),
    },
    unprocessed:true,
  });
};


//刷新token
export const refresh_token = () => {
  return http.post<DefaultResponseModel<GuestLoginModel>>({
    url: "/api/token/refresh",
    data: {
      refresh: getRefreshToken(false),
    },
    unprocessed:true,
  });
};
